import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=ee38df1c&scoped=true&"
import script from "./admin.vue?vue&type=script&lang=js&"
export * from "./admin.vue?vue&type=script&lang=js&"
import style0 from "./admin.vue?vue&type=style&index=0&id=ee38df1c&prod&lang=scss&scoped=true&"
import style1 from "./admin.vue?vue&type=style&index=1&id=ee38df1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee38df1c",
  null
  
)

export default component.exports